import { Account, AccountType, Profile, TrimmedAccountFragment } from '~/generated/graphql'
import { TrimmedCurrentAccountFragment } from '~/generated/graphql'

export function getDisplayName(account: TrimmedCurrentAccountFragment | TrimmedAccountFragment): string {
  if (!account.profile) {
    return ''
  }

  const profile = account.profile

  // For business accounts (Brand or TalentAgency), always use the name field
  if (account.type === AccountType.Brand || account.type === AccountType.TalentAgency) {
    return profile.name || ''
  }

  // For personal accounts, check for firstName/lastName first
  if (profile.firstName) {
    return profile.lastName ? `${profile.firstName} ${profile.lastName}` : profile.firstName
  }

  // Fallback to name field if firstName is not available
  return profile.name || ''
}
